module.exports={
	"Hash": "plain",
	"Name": "Plain",
	"Version": "1.0.0",
	"Description": "The least styled: system font, white or near-black ground, hairline borders, one quiet blue accent.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#ffffff",
					"Dark": "#181818"
				},
				"Secondary": {
					"Light": "#fafafa",
					"Dark": "#1c1c1c"
				},
				"Tertiary": {
					"Light": "#f4f4f4",
					"Dark": "#242424"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#1f1f1f"
				},
				"Hover": {
					"Light": "#f0f0f0",
					"Dark": "#262626"
				},
				"Selected": {
					"Light": "#eef2ff",
					"Dark": "#2a2f3a"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#1a1a1a",
					"Dark": "#e8e8e8"
				},
				"Secondary": {
					"Light": "#3a3a3a",
					"Dark": "#c8c8c8"
				},
				"Muted": {
					"Light": "#737373",
					"Dark": "#9a9a9a"
				},
				"Placeholder": {
					"Light": "#a0a0a0",
					"Dark": "#6a6a6a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#181818"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				},
				"PrimaryHover": {
					"Light": "#1d4ed8",
					"Dark": "#7db0ff"
				},
				"Accent": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				}
			},
			"Border": {
				"Light": "#e5e5e5",
				"Dark": "#2e2e2e"
			},
			"Status": {
				"Success": {
					"Light": "#1a7f37",
					"Dark": "#5fd08a"
				},
				"Warning": {
					"Light": "#9a6700",
					"Dark": "#d6a72a"
				},
				"Error": {
					"Light": "#c0322b",
					"Dark": "#ef6b63"
				},
				"Info": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#fafafa",
					"Dark": "#1c1c1c"
				},
				"Thumb": {
					"Light": "#e5e5e5",
					"Dark": "#2e2e2e"
				},
				"Hover": {
					"Light": "#737373",
					"Dark": "#9a9a9a"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#eef2ff",
					"Dark": "#2a2f3a"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#181818"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#2563eb",
					"Dark": "#5b9cff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
